import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import { MouseEvent } from 'react';
import { ChevronDown } from './icons';

export interface FilterButtonProps {
  label: string;
  /** highlights the trigger when the filter deviates from its default */
  active?: boolean;
  onClick: (e: MouseEvent<HTMLElement>) => void;
}

export function FilterButton({ label, active = false, onClick }: FilterButtonProps) {
  return (
    <ButtonBase
      onClick={onClick}
      // Durable, colour-independent hook for tests (COM-639 task 4 e2e
      // brief): asserting on `active` via computed border/background colour
      // is exactly what DateRangePicker.test.tsx's unit test already does
      // (see its own comment on why that's acceptable there - reading
      // computed style off a jsdom-attached node), but a Playwright e2e
      // asserting on colour is fragile (theme tweaks, anti-aliasing) and
      // opaque in failure output. `data-active` always stringifies (React
      // never omits `data-*`/`aria-*` attributes for a `false` value the way
      // it does for unknown non-data boolean props), so `[data-active="true"]`
      // is a stable selector regardless of styling.
      data-active={active}
      sx={{
        border: '1px solid',
        borderColor: active ? '#0E0E0E' : '#DEDEDE',
        borderRadius: '8px',
        px: 1.5,
        height: 36,
        backgroundColor: active ? '#F0F0F0' : '#FFFFFF',
        '&:hover': { borderColor: '#0E0E0E' },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
        <Typography fontSize={14} fontWeight={500}>
          {label}
        </Typography>
        {/* ChevronDown renders its own <svg size×size>, not an SvgIcon that
            forwards sx — wrapping it in another <SvgIcon> would nest two
            <svg> elements and the inner one's explicit width/height would
            win, ignoring any outer sx. Size it via its own `size` prop and
            state the color explicitly via inherited `color` on this Box. */}
        <Box sx={{ display: 'flex', color: 'text.secondary' }}>
          <ChevronDown size={14} />
        </Box>
      </Box>
    </ButtonBase>
  );
}
